import { useState, useEffect, useRef } from "react";
import useInView from './hooks/useInView';
import "./Animated.scss";

const Animated = () => {
  const [ref, isVisible] = useInView();
  const [showStart, setShowStart] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [showCover, setShowCover] = useState(false);
  const [moveUp, setMoveUp] = useState(false);
  const [showScroll, setShowScroll] = useState(false);
  const [scrollFadeOut, setScrollFadeOut] = useState(false);


  const startTimerRef = useRef(null);
  const scrollTimerRef = useRef(null);
  const activeRef = useRef(true);

  const startMessageCycle = () => {
    clearTimeout(startTimerRef.current);
    if (!activeRef.current) return;

    startTimerRef.current = setTimeout(() => {
      if (!activeRef.current) return;

      setShowStart(true);
      setFadeOut(false);

      setTimeout(() => {
        setFadeOut(true);
        setTimeout(() => {
          setShowStart(false);
          startMessageCycle();
        }, 300);
      }, 2000);
    }, 3000);
  };

  useEffect(() => {
    startMessageCycle();
    return () => clearTimeout(startTimerRef.current);
  }, []);

  const handleClick = () => {


    if (showStart) {
      setShowStart(false);
      setFadeOut(false);
      return;
    }

    if (!showCover) {
      setShowCover(true);
      activeRef.current = false;
      clearTimeout(startTimerRef.current);
    } else if (!moveUp) {
      setMoveUp(true);

      // Triangle clignotant après 3 secondes
      scrollTimerRef.current = setTimeout(() => {
        setShowScroll(true);

        // Disparition en douceur après 5 secondes
        setTimeout(() => {
          setScrollFadeOut(true); // déclenche le fondu sur le conteneur
          setTimeout(() => {
            setShowScroll(false);  // retire complètement du DOM après la transition
            setScrollFadeOut(false); // reset
          }, 500); // durée de la transition CSS
        }, 100000000000); // temps avant disparition
      }, 3000);
    }
  };

  useEffect(() => {
    return () => clearTimeout(scrollTimerRef.current);
  }, []);

  return (
    <><video
  className="background-video"
  autoPlay
  muted
  loop
  playsInline
  webkit-playsinline="true"
  preload="auto"
>
  <source src="/video-cover.mp4" type="video/mp4" />
</video><div
      ref={ref}
      className={`animated-container ${isVisible ? "fade-in" : ""}`}
      onClick={handleClick}
    >

      {/* Écran "Appuyez pour commencer" */}
      {showStart && (

        <div className={`start-screen ${fadeOut ? "fade-out" : ""}`}>
          <h2>Appuyez pour commencer</h2>
        </div>
      )}

      {/* Logo Hacienda */}
      <div
        className={`hacienda-logo ${showStart || (showCover) ? "hide" : ""
          }`}
      >
        <img src="logo-hacienda.webp" alt="logo du groupe" />
      </div>


      {/* Cover */}

      <div className={`animated-cover ${showCover ? "show" : ""} ${moveUp ? "move-up" : ""}`}>
        <img src="pochette_finale.jpg" alt="photo du groupe hacienda" />
      </div>

      {/* Out Now */}
      <div className={`out-now ${moveUp ? "visible" : ""}`}>
        <h2>Premier single</h2>
        <h4>Disponible</h4>
        <div className="music-stream-logos">
          <a href="https://open.spotify.com/intl-fr/artist/4ramJhr3lgUE4xPSO7Og4O"><img src="spotifylogo.png" alt="logo spotify" /></a>
          <a href="https://www.deezer.com/fr/album/830829471"><img src="deezerlogo.png" alt="logo deezer" /></a>
          <a href="https://music.apple.com/us/album/follow-the-stars-single/1843772346"><img src="applemusiclogo.svg" alt="logo apple music" />
          </a>
        </div>
        {/* Copyright */}
        <div className="copyright">
          <h6>©Hacienda 2025 Allrightsreserved</h6>
        </div>

        {/* Triangle clignotant sous le copyright */}
        {moveUp && showScroll && (
          <div className={`scroll-indicator ${scrollFadeOut ? "fade-out" : ""}`}>
            <span></span>
          </div>
        )}
      </div>


    </div></>
  );
};

export default Animated;